// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OUbS46tzH1NGDWsAKgtp {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0;
}

.jB1XZnpfFMt6dGTc032M {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.R3ktwOQaSRY8lpTFYgzp {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Location/Location.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px 0;\n}\n\n.listWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.loadingContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `OUbS46tzH1NGDWsAKgtp`,
	"listWrapper": `jB1XZnpfFMt6dGTc032M`,
	"loadingContainer": `R3ktwOQaSRY8lpTFYgzp`
};
export default ___CSS_LOADER_EXPORT___;
